import { ROUTES } from "../routes/routeNames";
import { UserRole } from "../models/userModels";
import controlPanelIcon from "../assets/svg/control_panel_icon.svg";
import controlPanelIconDark from "../assets/svg/control_panel_icon_hovered.svg";
import screeningToolIcon from "../assets/svg/screening_tool_icon.svg";
import screeningToolIconDark from "../assets/svg/screening_tool_icon_hovered.svg";
import metricsIcon from "../assets/svg/metrics_icon.svg";
import metricsIconDark from "../assets/svg/metrics_icon_hovered.svg";
import myFundsIcon from "../assets/svg/my_funds_icon.svg";
import myFundsIconDark from "../assets/svg/my_funds_icon_hovered.svg";
import stewardshipIcon from "../assets/svg/stewardship_icon.svg";
import stewardshipIconDark from "../assets/svg/stewardship_icon_hovered.svg";
import workspaceIcon from "../assets/svg/workspace_icon.svg";
import workspaceIconDark from "../assets/svg/workspace_icon_hovered.svg";
import addPortfolio from "../assets/svg/add_portfolio.svg";
import reportsList from "../assets/svg/reports_list.svg";
import aiLogo from "../assets/svg/ai_logo.svg";

export enum SideMenuTitle {
  CONTROL_PANEL = "Control Panel",
  SCREENING_TOOL = "Screening Tool",
  LINKAGE_DASHBOARD = "Linkage Dashboard",
  ASSESSMENT_INSIGHTS = "Assessment Insights",
  MY_FUNDS = "My Funds",
  STEWARDSHIP = "Stewardship",
  COMPASS_AI = "Compass AI",
  WORKSPACE = "Workspace",
  ADD_FILE = "Add File",
  REPORTS_LIST = "Reports List",
}

export type SideMenuItemConfig = {
  title: SideMenuTitle;
  icon: string;
  iconDark?: string;
  navigation: string;
  isActive: boolean;
  excludedRoles?: UserRole[];
  iconSize?: number;
};

export const SIDEMENU_ITEMS: SideMenuItemConfig[] = [
  {
    title: SideMenuTitle.CONTROL_PANEL,
    icon: controlPanelIcon,
    iconDark: controlPanelIconDark,
    navigation: ROUTES.CONTROL_PANEL,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
  {
    title: SideMenuTitle.SCREENING_TOOL,
    icon: screeningToolIcon,
    iconDark: screeningToolIconDark,
    navigation: ROUTES.SCREENING_TOOL,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
  {
    title: SideMenuTitle.LINKAGE_DASHBOARD,
    icon: metricsIcon,
    iconDark: metricsIconDark,
    navigation: ROUTES.LINKAGE_DASHBOARD,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
  {
    title: SideMenuTitle.MY_FUNDS,
    icon: myFundsIcon,
    iconDark: myFundsIconDark,
    navigation: ROUTES.MY_FUNDS,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
  {
    title: SideMenuTitle.STEWARDSHIP,
    icon: stewardshipIcon,
    iconDark: stewardshipIconDark,
    navigation: ROUTES.STEWARDSHIP,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
  {
    title: SideMenuTitle.WORKSPACE,
    icon: workspaceIcon,
    iconDark: workspaceIconDark,
    navigation: ROUTES.WORKSPACE,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
];

export const BOTTOM_SIDEMENU_ITEMS: SideMenuItemConfig[] = [
  {
    title: SideMenuTitle.COMPASS_AI,
    icon: aiLogo,
    navigation: ROUTES.COMPASS_AI,
    isActive: true,
  },
  {
    title: SideMenuTitle.ADD_FILE,
    icon: addPortfolio,
    navigation: ROUTES.ADD_FILE,
    isActive: true,
  },
  {
    title: SideMenuTitle.REPORTS_LIST,
    icon: reportsList,
    navigation: ROUTES.REPORTS_LIST,
    isActive: true,
    excludedRoles: [UserRole.MANAGER_UPLOAD],
  },
];
